var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100px"}},[_c('div',{attrs:{"id":"border"}}),_c('p',[_vm._v("CSS"),_c('br'),_vm._v("完全に理解した")])])}]

export { render, staticRenderFns }